import { Grid } from "@mui/material";
import * as React from "react";
import { required, TextInput, SimpleFormIterator, ArrayInput } from "react-admin";
import Transformer from "src/common/Transformer";
import { FileInput } from "src/components/file-input";
import { Edit, SimpleForm } from "src/enterprise/ra-rbac";
import { ProductCategoryEditComponent } from "./";

export const ProductCategoryEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt"],
      update: {
        dynamic: data.dynamic && data.dynamic.length ? Object.fromEntries(data.dynamic.map(item => [item.name, item.value])) : []
      },
    });

    return data;
  };

  return (
    <Edit
      component={ProductCategoryEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <SimpleForm
        defaultValues={(record) => ({
          ...record,
          dynamic: record.dynamic
            ? Object.entries(record.dynamic).map(([name, value]) => ({ name, value }))
            : [],
        })}
      >
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} lg={8}>
            <TextInput disabled source="id" />
          </Grid>
          <Grid item sm={12} lg={8}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item sm={12} lg={8}>
            <TextInput source="slug" />
          </Grid>
          <Grid item sm={12} lg={8}>
            <ArrayInput source="dynamic" helperText="Set dynamic params to use for listing instead of category id.">
              <SimpleFormIterator inline>
                <TextInput source="name" />
                <TextInput source="value" />
              </SimpleFormIterator>
            </ArrayInput> 
          </Grid>
          <Grid item sm={12} lg={8}>
            <TextInput
              source="description"
              multiline
              resettable
              sx={{
                "#description": { minHeight: "90px", height: "100%" },
                minWidth: "35vw",
              }}
            />
          </Grid>
          <Grid item sm={12}>
            <FileInput
              source="image"
              fileTypes={["JPG", "PNG", "GIF", "SVG", "WEBP", "MP4"]}
              multiple={false}
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
